import BaseErrorHandler from '@/apis/errorHandler/handler/BaseErrorHandler'
import  AlertTypeEnum from '@/apis/errorHandler/AlertTypeEnum'

export default class UserFriendlyException extends BaseErrorHandler {
    protected Code: string = "Warning";
    protected AlertType:AlertTypeEnum=AlertTypeEnum.WARNING;
    constructor(messageKey?: string, message?: string) {
        super(messageKey, message);
    }
    customizeAction(): void {
    }
}
